export default __webpack_public_path__ + "static/media/warning--roadworks--g6.a04ce9d6.png";